
export * from './LoggerTimer';


// WEBPACK FOOTER //
// ./src/index.ts